import { NestedHome } from "@habity/types";
import { HomeDataBuilder } from './data-builder';
import { surroundingFields } from './surrounding-fields';

export const getSurroundingData = (home: NestedHome) => {
  return new HomeDataBuilder()
    .withFields(surroundingFields)
    .build({ home });
}